"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTransactionsTranslate = void 0;
exports.defaultTransactionsTranslate = {
    transactions: 'Transaction History',
    otherTransactions: 'Other Transactions',
    buildingTransactions: 'Building Transactions',
    transactionDate: 'Date',
    transactionName: 'Property',
    transactionFloor: 'Floor',
    transactionFlat: 'Flat',
    transactionLastRegDate: 'Last Reg. Date',
    transactionLastRegChange: 'Last Reg. Change',
    transactionAnnualReturn: 'Annualized Return',
    transactionPrice: 'Price',
    transactionSize: 'Size',
    transactionPpsf: 'Price / SF',
    grossAbbr: 'SF (G)',
    grossAbbr2: '(G)',
    saleableAbbr: 'SF (S)',
};
